import { serialize } from 'components/text_editor/text_editor_config';
import { omit } from 'lodash';

export const CARTE_VITALE_REGEX =
  /(\d)(\d{2})(\d{2})(\d{1}[AB0-9])(\d{3})(\d{3})(\d{2})/g;

export const hasCustomerChanged = (newData, oldData) => {
  return (
    JSON.stringify({
      firstName: newData.firstName,
      lastName: newData.lastName,
      location: newData.location,
      patientRights: newData.patientRights,
      email: newData.email,
      phone: newData.phone,
      city: newData.city,
      address: newData.address,
      carteVitale: newData.carteVitale,
      dateOfBirth: newData.dateOfBirth,
      nurseNotes: Array.isArray(newData.nurseNotes)
        ? newData.nurseNotes.map(serialize).join('')
        : newData.nurseNotes,
      doctorNotes: Array.isArray(newData.doctorNotes)
        ? newData.doctorNotes.map(serialize).join('')
        : newData.doctorNotes,
      height: newData.height,
      weight: newData.weight,
      bmi: newData.bmi,
      gender: newData.gender,
      age: newData.age,
    }) !==
    JSON.stringify({
      firstName: oldData.firstName,
      lastName: oldData.lastName,
      location: oldData.location,
      patientRights: oldData.patientRights,
      email: oldData.email,
      phone: oldData.phone,
      city: oldData.city,
      address: oldData.address,
      carteVitale: oldData.carteVitale,
      dateOfBirth: oldData.dateOfBirth,
      nurseNotes: oldData.nurseNotes,
      doctorNotes: oldData.doctorNotes,
      height: oldData.height,
      weight: oldData.weight,
      bmi: oldData.bmi,
      gender: oldData.gender,
      age: oldData.age,
    })
  );
};

export const sanitize = (customer) =>
  omit(customer, [
    'responses',
    'polygraphies',
    'teleconsultations',
    'treatments',
    'tasks',
    'files',
    'polysomnographies',
    'user',
    'customerDoctors',
  ]); // do not send these fields to the backend

export const getPaymentModalLabel = (customer) => {
  if (
    customer.patientRights ===
    'required-to-pay-for-consultations-and-examinations'
  )
    return 'is required to pay for examinations';

  if (
    customer.patientRights === 'required-to-pay-for-consultations-only' ||
    customer.patientRights ===
      'not-required-to-pay-for-consultations-and-examinations'
  )
    return 'is not required to pay for examinations';

  if (!customer.patientRights) return "patient's rights are unknown";
};
